







































import { Vue, Component } from 'vue-property-decorator';
import { getCreaten, getUser } from '../api';
import VoteButton from '../components/VoteButtonNew.vue';
import { isWeiXin } from '@/common/ts/common';
import qs from 'qs';
import { Toast } from 'vant';

@Component({
  components: {
    VoteButton,
  },
})
export default class Rule extends Vue {
  id: any = this.$route.query.id;
  intonowx: boolean = true;
  h_size: string = '';
  w_size: string = '';
  showimg: string = '';
  datainfo: any = {};
  voteName: string = '2023project/q2/2023cmbyz';
  unionId: any = '';
  async mounted() {
    this.unionId = window.localStorage.getItem('unionid');
    if (!isWeiXin()) {
      Toast('请在微信客户端中打开');
      return false;
    } else if (!this.unionId && isWeiXin()) {
      this.WechatLogin();
      return false;
    }
    getCreaten(this.id).then((res: any) => {
      this.h_size = '';
      this.w_size = '';
      this.datainfo = res.data;
      this.showimg = this.datainfo.cover;
      var currentImg = new Image();
      currentImg.src = this.datainfo.cover;
      currentImg.onload = () => {
        const width = currentImg.width;
        const height = currentImg.height;
        if (width / height > 1) {
          //以宽为准
          const w_factor = parseFloat((width / 330).toFixed(5));
          this.w_size = '100%';
          this.h_size = parseFloat((height / w_factor).toFixed(5)) + 'px';
        } else if (width / height < 1) {
          //以高为准
          const h_factor = parseFloat((height / 330).toFixed(5));
          this.h_size = '100%';
          this.w_size = parseFloat((width / h_factor).toFixed(5)) + 'px';
        } else {
          this.h_size = '100%';
          this.w_size = '100%';
        }
      };
    });
  }
  votSuccess(data: any, index: any) {
    window.location.reload();
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
